import MPVaspsTable from './MPVaspsTable'

export default MPVaspsTable
